<div class="card overflow-hidden rounded-10 shadow">
  <div class="card-body" *ngIf="isLoaded">
    <app-loading-dash [size]="'card-middle'" />
  </div>
  <div class="card-body" *ngIf="!isLoaded">
    <div class="card-order">
      <h6 class="mb-3">{{ 'common.averageSalesTicket' | translate }}</h6>
      <h2 class="text-end">
        <i class="mdi mdi-poll icon-size float-start purple-color"></i
        ><span class="number-font"
          >
          {{
            averageTicket
              | formatCurrency
          }}</span
        >
      </h2>
      <p class="mb-0">
        R$ {{ 'common.fromLastWeek' | translate }} <span class="float-end"
          >
          {{
            averageTicketLastValue
              | formatCurrency
          }}</span
        >
      </p>
    </div>
  </div>
</div>
